import i18n from 'i18next'

import { type RouterInput } from '@campai/lib-web/utils/trpc'

export type Status = NonNullable<RouterInput['product']['feedback']['listTickets']['status']>

export const STATUS_OPTIONS = ['new', 'planned', 'inProgress', 'done', 'rejected'] as const

export const getStatusLabel = (status: Status) => {
    switch (status) {
        case 'new':
            return i18n.t('product.feedback.shared.status.new')
        case 'planned':
            return i18n.t('product.feedback.shared.status.planned')
        case 'inProgress':
            return i18n.t('product.feedback.shared.status.inProgress')
        case 'done':
            return i18n.t('product.feedback.shared.status.done')
        case 'rejected':
            return i18n.t('product.feedback.shared.status.rejected')
    }
}

export const getStatusFilterLabel = (status: Status | 'all') => {
    switch (status) {
        case 'all':
            return i18n.t('product.feedback.home.statusFilter.all')
        case 'new':
            return i18n.t('product.feedback.home.statusFilter.new')
        case 'planned':
            return i18n.t('product.feedback.home.statusFilter.planned')
        case 'inProgress':
            return i18n.t('product.feedback.home.statusFilter.inProgress')
        case 'done':
            return i18n.t('product.feedback.home.statusFilter.done')
        case 'rejected':
            return i18n.t('product.feedback.home.statusFilter.rejected')
    }
}
